// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Uy","innerTile":"Vy","heading":"Wy","instaTileBtn":"Xy","disabled":"Yy","instaTileElement":"Zy","instagramPic":"_y"};